import SectionHeader from './SectionHeader'
import AccordionList from './AccordionList'
import Questions from './Questions'

const Faq = () => {
  return (
    <>
      <div className="mt-10 relative max-w-[90%] lg:max-w-[73.125rem] mx-auto ">
        <SectionHeader
          title="Need help? Check out our"
          className="max-w-[90%] lg:max-w-[73.125rem] mx-auto px-8 lg:px-40 text-center mt-3 lg:mt-20 gap-1 lg:gap-3"
          subTitleStyle="text-[28px] md:text-5xl leading-tight md:leading-[72px] md:whitespace-normal"
          subtitle="Frequently Asked Questions"
          description="Here are some common questions and answers about our community and the services we provide"
          descriptionStyle="text-sm md:text-lg md:text-center"
        />
        <AccordionList />
        <Questions />
      </div>
    </>
  )
}

export default Faq
